import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Goes back `steps` pages in the history once rendered. <Navigate> took a
// number for this in React Router's 6.0 beta; since 6.0 it takes paths only.
const NavigateBack = ({ steps = 1 }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(-steps);
  }, [navigate, steps]);

  return null;
};

export default NavigateBack;
